<template>
  <transition name="fade">
    <div v-show="toastShow" class="toast" :class="toastType">
      <img v-show="icon" class="icon" :src="icon" alt />
      <p v-show="toastString" class="tip-text">{{ toastString }}</p>
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Toast extends Vue {
  toastShow = false;
  @Prop({ type: String }) toastString!: '';
  @Prop({ type: String }) toastType!: '';
  @Prop({ type: String }) icon!: '';
}
</script>

<style lang="scss" scoped>
// @import '../../style/enrolment.scss';

.toast {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px 0;
  &.success {
    background: #daeae3;
  }
  &.failure {
    background: #ffeeee;
  }
  .icon {
    width: 42px;
    height: 42px;
    border-radius: 50%;
  }

  p {
    margin-left: 26px;
    color: #383333;
    font-weight: normal;
    font-size: 30px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }
}
</style>
